import './App.css';
import CounterContainer from './containers/Counter';
function App() {
  return (
    <div className="App">
      <CounterContainer/>
    </div>
  );
}

export default App;
